import React , {useEffect , useState  } from 'react'
import Footer from '../components/Footer'
import SideFooter from '../components/SideFooter'
import {  Link, useNavigate } from 'react-router-dom';
import NavbarHome from '../components/HomeComponents/NavbarHome';
import { getDocs , collection , db  } from '../firebase';
import Aos from 'aos';
import "aos/dist/aos.css";


const ExperiencesPage = () => {

  let navigate = useNavigate();
  
  const [ experinceArray , setExperincesArray ] = useState([]);

  useEffect(  () => {
      window.scrollTo(0, 0);
    const getExperincesData = async () => { 
      const querySnapshot = await getDocs(collection(db, "experiences"));
      const experincesdataarray = querySnapshot.docs
      .map((doc) => ({ ...doc.data(), id: doc.id }));
        
      setExperincesArray(experincesdataarray);
     
    }
    getExperincesData();
  } , []);

  useEffect(() => {
    Aos.init( {  duration: 1200 } )
  } , []);




  return (
    <div className="main_homepage" >

    
    <NavbarHome />

 
    <div className="packages_explore explroe_hero_3" data-aos="zoom-out" data-aos-duration="450"   data-aos-easing="ease-in-quad" data-aos-mirror="true"   >

<div className="content_top_explore">
<h1 className="heroarea_subheadline">  تصفح التجارب السياحية </h1>
<div className="underline_line_thick"></div>
</div>



</div>

<div className="section expereinces_section ">

<div className="d-flex-c f-sp top_area_headlines container-mid">

<div className="d-flex-c  mb-2" data-aos="fade-right" data-aos-delay="30" data-aos-easing="ease" data-aos-mirror="true" >

<div className="info_box"></div>
<h1 className="main_headline" >     أكتشف ابرز ألاماكن    </h1>
</div>

<div className="sliding_back" onClick={() => navigate('/') } >
        <img src="/images/icons/left-arrow.png" alt="" />
      </div>

</div>




</div>
 
 <div className="section most_features_section container-sm">

 <div className="grid_places mt-4">

{experinceArray && experinceArray.map(( { id , experince_name  , experince_photos , experince_price , experince_location } ) => (

  <div className="single_experince_div" data-aos="fade-up-right" data-aos-delay="20" data-aos-easing="linear" data-aos-mirror="true" data-aos-duration="250"  >

  <Link to={`/experinces/${id}`}>
  <img src={experince_photos[0]}  alt="" className="experince_img" />
  </Link>


<div className=" body_experince_card">
<p className="location_experince_sm mt-1-small"> {experince_location} </p>

<h1 className="location_headline"> { experince_name }</h1>

<p className="experince_price mt-1"> سعر يبدأ من   <br /> <span className="span_bold">{experince_price} ريال </span> </p>

<Link to={`/experinces/${id}`}>
<div className="d-flex-c f-sp">

<button className="btn_category ">  احجز الان </button>

<img src="/images/icons/left-arrow-purple.png" alt="" className="icon_experince" />
</div>
</Link>

</div>

</div>

)) }

</div>


</div>
    
    <SideFooter />

    <Footer />
    </div>
  )
}

export default ExperiencesPage